const ENUMS = {
  AUTH: "AUTH",

  API_MSG: {
    CANCELLED: "CANCELLED",
  },

  MAPS: {
    DEFAULT_LAT: 51.5074,
    DEFAULT_LNG: 0.1278,
    ZOOM_LEVEL: 16, // Increased zoom level
  },
};

export default ENUMS;
